import { prefixObjectValues } from '../utils';

const page = prefixObjectValues(
  {
    educationTab: 'education-tab',
    trainingTab: 'training-tab',
  },
  'academic-view'
);
export default {
  ...page,
};
